import React from 'react';

export const Label = ({ htmlFor, children, className = '', style, error = false }) => {
  return (
    <label 
      htmlFor={htmlFor} 
      className={`label ${className}`}
      style={style}
    >
      {children}
    </label>
  );
};
